var map = {
	"./thewest-digital-hero-cropped.jpg": 586,
	"./thewest-digital-hero-variation-a-cropped.jpg": 432,
	"./thewest-digital-hero-variation-a.jpg": 587,
	"./thewest-digital-hero-variation-b-cropped.jpg": 588,
	"./thewest-digital-hero-variation-b.jpg": 1095,
	"./thewest-digital-hero-variation-experiment2-cropped.jpg": 589,
	"./thewest-digital-hero-variation-experiment2.jpg": 1096,
	"./thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 590,
	"./thewest-digital-hero-variation-vanishing-cousins.jpg": 1097,
	"./thewest-digital-hero.jpg": 1098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1094;